const toggleControlsPalette = (tokens) => {
    return {
        size: {
            default: tokens.toggleControlsSizeDefault,
            small: tokens.toggleControlsSizeS
        },
        padding: tokens.toggleControlsPadding,
        border: {
            width: tokens.toggleControlsBorderWidthWrapper,
            radius: {
                square: tokens.toggleControlsRadiusSquare,
                round: tokens.toggleControlsRadiusRound
            }
        },
        wrapper: {
            unselected: {
                background: {
                    default: tokens.toggleControlsColorWrapperBgUnselectedDefault,
                    hover: tokens.toggleControlsColorWrapperBgUnselectedHover,
                    focus: tokens.toggleControlsColorWrapperBgUnselectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBgUnselectedDisabled
                },
                border: {
                    default: tokens.toggleControlsColorWrapperBorderUnselectedDefault,
                    hover: tokens.toggleControlsColorWrapperBorderUnselectedHover,
                    focus: tokens.toggleControlsColorWrapperBorderUnselectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBorderUnselectedDisabled
                }
            },
            selected: {
                background: {
                    default: tokens.toggleControlsColorWrapperBgSelectedDefault,
                    hover: tokens.toggleControlsColorWrapperBgSelectedHover,
                    focus: tokens.toggleControlsColorWrapperBgSelectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBgSelectedDisabled
                },
                border: {
                    default: tokens.toggleControlsColorWrapperBorderSelectedDefault,
                    hover: tokens.toggleControlsColorWrapperBorderSelectedHover,
                    focus: tokens.toggleControlsColorWrapperBorderSelectedFocus,
                    disabled: tokens.toggleControlsColorWrapperBorderSelectedDisabled
                }
            },
            indeterminate: {
                background: {
                    default: tokens.toggleControlsColorWrapperBgIndeterminateDefault,
                    hover: tokens.toggleControlsColorWrapperBgIndeterminateHover,
                    focus: tokens.toggleControlsColorWrapperBgIndeterminateFocus,
                    disabled: tokens.toggleControlsColorWrapperBgIndeterminateDisabled
                },
                border: {
                    default: tokens.toggleControlsColorWrapperBorderIndeterminateDefault,
                    hover: tokens.toggleControlsColorWrapperBorderIndeterminateHover,
                    focus: tokens.toggleControlsColorWrapperBorderIndeterminateFocus,
                    disabled: tokens.toggleControlsColorWrapperBorderIndeterminateDisabled
                }
            }
        },
        icon: {
            unselected: {
                background: {
                    default: tokens.toggleControlsColorIconBgUnselectedDefault,
                    hover: tokens.toggleControlsColorIconBgUnselectedHover,
                    focus: tokens.toggleControlsColorIconBgUnselectedFocus,
                    disabled: tokens.toggleControlsColorIconBgUnselectedDisabled
                }
            },
            selected: {
                background: {
                    default: tokens.toggleControlsColorIconBgSelectedDefault,
                    hover: tokens.toggleControlsColorIconBgSelectedHover,
                    focus: tokens.toggleControlsColorIconBgSelectedFocus,
                    disabled: tokens.toggleControlsColorIconBgSelectedDisabled
                }
            },
            indeterminate: {
                background: {
                    default: tokens.toggleControlsColorIconBgIndeterminateDefault,
                    hover: tokens.toggleControlsColorIconBgIndeterminateHover,
                    focus: tokens.toggleControlsColorIconBgIndeterminateFocus,
                    disabled: tokens.toggleControlsColorIconBgIndeterminateDisabled
                }
            }
        }
    };
};
export default toggleControlsPalette;
//# sourceMappingURL=toggleControls.js.map